import {Injectable} from '@angular/core';
import {BaseDao} from '../../../../../base-dao';
import {HipcomBulkUpdateCurrentSoftwareVersion} from '../../../../../models';
import {KluhManagerValidator} from '../../../../../validators/kluh-manager-validator';
import {R2CloudHttpApiService} from '../../../../../r2-cloud-http-api.service';

@Injectable()
export class HipcomBulkUpdateCurrentSoftwareVersionDaoService extends BaseDao<HipcomBulkUpdateCurrentSoftwareVersion> {
    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'partners-hipcom-bulk-update-current-software-version');
    }

}
